// Hook do modal "Alterar valor de todos os bairros em massa".
// Dois modos: "definir" (todos ficam com o mesmo valor) e "ajustar"
// (soma/subtrai R$X do valor atual de cada bairro — piso 0 no backend).

import { useCallback, useState } from "react";
import { toast } from "sonner";
import { bairrosApi } from "../api/bairrosApi";

export function useValorMassa({ onSucesso }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [valor, setValor] = useState("");
  const [modo, setModo] = useState("definir"); // "definir" | "ajustar"
  const [operacao, setOperacao] = useState("somar"); // "somar" | "subtrair"
  const [saving, setSaving] = useState(false);

  const abrir = useCallback(() => {
    setValor("");
    setModo("definir");
    setOperacao("somar");
    setModalOpen(true);
  }, []);

  const confirmar = useCallback(async () => {
    const v = parseFloat(String(valor).replace(",", "."));
    if (isNaN(v) || v < 0 || (modo === "ajustar" && v === 0)) {
      toast.error("Digite um valor válido");
      return;
    }
    setSaving(true);
    try {
      if (modo === "ajustar") {
        const delta = operacao === "somar" ? v : -v;
        const { data } = await bairrosApi.ajustarValorEmTodos(delta);
        toast.success(data?.message || "Valores ajustados em todos os bairros!");
      } else {
        await bairrosApi.setarValorEmTodos(v);
        toast.success("Valor de entrega atualizado em todos os bairros!");
      }
      setModalOpen(false);
      setValor("");
      onSucesso?.();
    } catch (e) {
      toast.error("Erro ao atualizar valores");
    } finally {
      setSaving(false);
    }
  }, [valor, modo, operacao, onSucesso]);

  return {
    modalOpen,
    setModalOpen,
    valor,
    setValor,
    modo,
    setModo,
    operacao,
    setOperacao,
    saving,
    abrir,
    confirmar,
  };
}
